// extracted by mini-css-extract-plugin
module.exports = {"card":"PizzaCard_card__1BmPn","toppings":"PizzaCard_toppings__3lhMb","filters":"PizzaCard_filters__2IdD3"};